import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Loader from './components/Loader';

// Non-lazy components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import PrivateRoute from "./components/PrivateRoute";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";

import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Toaster } from 'react-hot-toast';
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";

// Lazy loaded components
const Home = React.lazy(() => import('./components/Home'));
const Lessons = React.lazy(() => import('./components/Lessons'));
const About = React.lazy(() => import('./components/About'));
const ContactSection = React.lazy(() => import('./components/ContactSection'));
const SignupPage = React.lazy(() => import('./components/SignupPage'));
const Login = React.lazy(() => import('./components/Login'));
const Dashboard = React.lazy(() => import('./components/Dashboard'));
const AdminPage = React.lazy(() => import('./components/AdminPage'));
const GetStarted = React.lazy(() => import('./components/getStarted'));

function App() {
  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <Router>
        <div className="min-h-screen bg-gradient-to-r from-yellow-50 to-white">
          <Navbar />

          <Suspense fallback={<Loader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/Lessons" element={<Lessons />} />
              <Route path="/About" element={<About />} />
              <Route path="/Contact" element={<ContactSection />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<ProtectedAdminRoute><AdminPage /></ProtectedAdminRoute>} />
              <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
              <Route path="/get-started" element={<GetStarted />} />
              <Route path="*" element={<div className="text-center mt-20 text-2xl">404 - Page Not Found</div>} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              

              {/* Add more routes if needed */}
            </Routes>
          </Suspense>

          <ToastContainer position="top-center" autoClose={3000} />
          <Footer />
        </div>
      </Router>
    </>
  );
}

export default App;
